module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_library.js
 ** module id = 42
 ** module chunks = 0
 **/